import { Box, getBoxStyle, Resolution } from "./canvas-geometry";

type Props = {
  box: Box;
  resolution: Resolution;
};

export default function SelectionMarquee({ box, resolution }: Props) {
  return (
    <div
      className="pointer-events-none absolute bg-blue-400/30 outline-1 outline-blue-400 outline-solid"
      style={getBoxStyle(box, resolution)}
    />
  );
}
